"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClipPath = exports.getElementPositionProps = exports.getImageProps = exports.isDataURL = void 0;
const number_utils_1 = require("./number-utils");
function isDataURL(value) {
    return !!value.match(/^\s*data:(\w+\/[-.\w]+(?:\+[-.\w]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i);
}
exports.isDataURL = isDataURL;
function getImageProps(image) {
    const url = image.getAttribute('xlink:href');
    const width = (0, number_utils_1.convertToNumber)(image.getAttribute('width'));
    const height = (0, number_utils_1.convertToNumber)(image.getAttribute('height'));
    return {
        url,
        width,
        height,
    };
}
exports.getImageProps = getImageProps;
function getElementPositionProps(element) {
    var _a;
    const id = (_a = element.getAttribute('id')) !== null && _a !== void 0 ? _a : null;
    const width = (0, number_utils_1.convertToNumber)(element.getAttribute('width')) || null;
    const height = (0, number_utils_1.convertToNumber)(element.getAttribute('height')) || null;
    const top = (0, number_utils_1.convertToNumber)(element.getAttribute('y')) || (width ? 0 : null);
    const left = (0, number_utils_1.convertToNumber)(element.getAttribute('x')) || (width ? 0 : null);
    return {
        id,
        top,
        left,
        height,
        width,
    };
}
exports.getElementPositionProps = getElementPositionProps;
function getClipPath(element) {
    const clipPathAttribute = element.getAttribute('clip-path');
    if (!clipPathAttribute) {
        return null;
    }
    const clipPathId = clipPathAttribute
        .replace('url(', '')
        .replace(')', '')
        .replace(/"/g, '')
        .trim();
    return document.querySelector(clipPathId);
}
exports.getClipPath = getClipPath;
//# sourceMappingURL=dom-utils.js.map